import { union } from 'lodash';
import { FieldValueType } from 'api/tasks';
import { TaskField } from 'stores/fields';
import { AssigneeValue, UpdatableSquad } from './fields';

export type TaskFieldValue = FieldValueType | AssigneeValue[];

export interface PartialValue {
  field: TaskField;
  from?: TaskFieldValue;
  to: TaskFieldValue;
}

type FieldPatch = { fieldId: number; fieldValue: FieldValueType };
type Patch = Record<string, unknown> & { fields?: FieldPatch[] } & {
  assignee?: UpdatableSquad;
};
const defaultFieldPatchValue = ({ field: { fieldName }, to }: PartialValue) => {
  switch (fieldName) {
    case 'assignee':
      return { assignee: AssigneeValue.toSquad(to as AssigneeValue[]) };
    case 'project':
      return {};
    case 'completedAt':
      return {
        fieldName: 'completedAtActual',
        to: new Date(to as unknown as Date).getTime(),
      };
    default:
      return { [fieldName]: to as FieldValueType };
  }
};

const _patch = ({ field, to }: PartialValue): Patch =>
  field.customField
    ? { fields: [{ fieldId: field.fieldId, fieldValue: to as FieldValueType }] }
    : defaultFieldPatchValue({
        field,
        to,
      });

export const PartialValue = {
  toPatch: (values: PartialValue[]): Record<string, unknown> =>
    values.reduce((patch, value) => {
      const { fields = [], ...rest } = _patch(value);

      return {
        ...patch,
        ...rest,
        fields: union(patch.fields ?? [], fields),
      };
    }, {} as Patch),
};
